export default __webpack_public_path__ + "static/media/business-02.09d66033.jpg";